module.exports = __webpack_public_path__ + "static/media/setReminding.e6192bd4.svg";